if (typeof ProductBundler !== 'function') {
  class ProductBundler extends HTMLElement {
    constructor() {
      super();
      if (this.querySelector('css-slider')) {
        this.querySelector('css-slider').addEventListener('ready', () => {
          this.init();
        });
      } else {
        this.init();
      }
    }

    init() {
      this.bundleProducts = [...this.querySelectorAll('[data-js-bundler-product]')];
      this._bundleTemplate = this.querySelector('[data-js-bundler-product]').cloneNode(true);
      this._bundleMin = parseInt(this.dataset.minimum) || 2;
      this._bundleMax = 10;

      // Initialize progress bar elements
      this.progressFill = document.querySelector(".progress-fill");
      this.remainingProductsText = document.getElementById("remaining-products");
      this.totalPriceText = document.getElementById("total-price");
      this.normalTotalPriceText = document.querySelectorAll(".normal-total-price");
      this.savingsText = document.querySelectorAll(".savings-price");

      
      // Initialize with correct values
      this.addedProducts = 0;
      this.totalPrice = 0;
      this.updateProgressBar(0);

      // Set up event listeners
      this.querySelectorAll('[data-js-product-add-to-cart]').forEach(elm => {
        elm.addEventListener('click', e => {
          e.preventDefault();
          const product = e.target.closest('[data-js-product-item]');
          product.querySelector('.button__text').innerHTML = "Added to bundle";
          const id = product.querySelector('.product-form').querySelector('input[name="id"]').value;
          const variant = product.querySelector('product-variants').getVariantData().find(variant => {
            return variant["id"] == id;
          });
          this.addToBundle(variant, product);
          this.classList.add('opened');
          this.updateProgressBar(1);
          this.dispatchBundleUpdatedEvent();
        });
        
        elm.disabled = false;
        elm.classList.add('selectfirstavailablevariant');
        elm.classList.remove('disabled');   
      });

      this.querySelectorAll('[data-js-bundler-product-remove]').forEach(elm => {
        elm.addEventListener('click', e => {
          this.clearSlot(e.target.closest('[data-js-bundler-product]'));
          this.updateProgressBar(-1);
          this.dispatchBundleUpdatedEvent();
        });
      });

      this.querySelector('[data-js-bundler-toggle]').addEventListener('click', e => {
        if (window.innerWidth < 768) {
          this.classList.toggle('opened');
        }
      });

      this.querySelector('[data-js-add-bundle-to-cart]').addEventListener('click', e => {
        e.preventDefault();
        this.addBundleToCart();
      });
      
      const progressAddToCartBtn = document.querySelector('.sticky-progress-bar .add-to-cart-btn');
      if (progressAddToCartBtn) {
        progressAddToCartBtn.addEventListener('click', e => {
          e.preventDefault();
          this.addBundleToCart();
        });
      }

      this.updateAddToCartButton();
      
      // Initialize remaining products text
      if (this.remainingProductsText) {
        if (document.body.classList.contains('template-page-large-bundle')) {
          this.remainingProductsText.textContent = "Add 2 Plants to get 10% OFF";
        }  else if (document.body.classList.contains('template-page-plant_food_byob')) {
          this.remainingProductsText.textContent = "Add any 3 plant foods and get 25% OFF";
        }else if (document.body.classList.contains('template-page-mylo_byob')) {
          this.remainingProductsText.textContent = "Add 4 Plant for Just ₹999!";
        }else if (document.body.classList.contains('template-page-mylo5-999')) {
          this.remainingProductsText.textContent = "Add 5 Plant for Just ₹999!";
        }else if (document.body.classList.contains('template-page-repot_deal')) {
          this.remainingProductsText.textContent = "Add 2  Plants  for Just ₹649!";
        }  else {
          this.remainingProductsText.textContent = "Add 2 plants to level up";
        }
      }
    }

getCurrentVariantPrice() {
  // Find the first added product in the bundle
  const addedProduct = this.bundleProducts.find(prod => !prod.classList.contains('bundler-product--empty'));
  if (!addedProduct) return '0';
  
  // Get the variant ID
  const variantId = addedProduct.dataset.id;
  
  // Find the product element in the product grid
  const productElement = addedProduct.product;
  if (!productElement) return '0';
  
  // Get the variant data
  const variants = productElement.querySelector('product-variants').getVariantData();
  const variant = variants.find(v => v.id == variantId);
  
  // Format price as "3,399" without decimals
  if (variant && variant.price) {
    const priceNumber = parseFloat(variant.price);
    return priceNumber.toLocaleString('en-IN', {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    });
  }
  return '0';
}

    calculatePerItemPrice(count, total) {
      if (count === 0) return 0;
      return (total / count).toFixed(2);
    }
    
    dispatchBundleUpdatedEvent() {
      const filledSlots = this.bundleProducts.filter(elm => !elm.classList.contains('bundler-product--empty')).length;
      const event = new CustomEvent('bundle-updated', { 
        detail: { 
          count: filledSlots,
          totalPrice: this.totalPrice,
          perItemPrice: this.calculatePerItemPrice(filledSlots, this.totalPrice)
        }
      });
      document.dispatchEvent(event);
    }
syncStickyBar() {
  const stickyProducts = document.querySelectorAll('[data-js-sticky-product]');
  const filledSlots = this.bundleProducts.filter(elm => !elm.classList.contains('bundler-product--empty'));

  stickyProducts.forEach((el, index) => {
    const imgEl = el.querySelector('[data-js-sticky-product-image]');
    if (filledSlots[index]) {
      const imgTag = filledSlots[index].querySelector('img');
      if (imgTag) {
        imgEl.style.backgroundImage = `url(${imgTag.src})`;
        el.classList.remove('bundler-product--empty');
      }
    } else {
      imgEl.style.backgroundImage = '';
      el.classList.add('bundler-product--empty');
    }
  });

  // Also update sticky total price
  const stickyPrice = document.querySelector('.sticky-progress-bar #total-price');
  if (stickyPrice) {
    stickyPrice.textContent = this.totalPrice.toLocaleString('en-IN', {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    });
  }
}

updateProgressBar(change) {
  // Update product count
  this.addedProducts = Math.max(0, this.addedProducts + change);
  
  // Calculate price based on template
  const isCustomBundle = document.body.classList.contains('template-page-custom-bundle');
  const poeticmain = document.body.classList.contains('template-page-byob-poetic-merchendising ');
  const isAuraByob = document.body.classList.contains('template-page-aura-byob');
  const isLargeByob = document.body.classList.contains('template-page-large-bundle');
  const isFoodByob = document.body.classList.contains('template-page-plant_food_byob');
  const isMyloByob = document.body.classList.contains('template-page-mylo_byob');
  const isMylo5Byob = document.body.classList.contains('template-page-mylo5-999');
  const poetic2 = document.body.classList.contains('template-page-poetic-byob-exclusive');
  const repot = document.body.classList.contains('template-page-repot_deal');
  const planters = document.body.classList.contains('template-page-planter_byob');
  
  if (isCustomBundle) {
    if (this.addedProducts <= 2) {
      this.totalPrice = this.addedProducts * 279.8;
    } else if (this.addedProducts === 3) {
      this.totalPrice = 999;
    } else if (this.addedProducts === 4) {
      this.totalPrice = 1249;
    } else if (this.addedProducts === 5) {
      this.totalPrice = 1399;
    }else if (this.addedProducts === 6) {
      this.totalPrice = 2499;
    }
  } else if (poetic2) {
    if (this.addedProducts <= 2) {
      this.totalPrice = this.addedProducts * 279.8;
    } else if (this.addedProducts === 3) {
      this.totalPrice = 899;
    } else if (this.addedProducts === 4) {
      this.totalPrice = 1249;
    } else if (this.addedProducts === 5) {
      this.totalPrice = 1399;
    }else if (this.addedProducts === 6) {
      this.totalPrice = 2499;
    }
  } else if (repot) {
    if (this.addedProducts <= 2) {
      this.totalPrice = this.addedProducts * 274.5;
    } else if (this.addedProducts === 2) {
      this.totalPrice = 549;
    } 
  }else if (poeticmain) {
    if (this.addedProducts <= 2) {
      this.totalPrice = this.addedProducts * 279.8;
    } else if (this.addedProducts === 3) { 
      this.totalPrice = 999;
    } else if (this.addedProducts === 4) {
      this.totalPrice = 1249;
    } else if (this.addedProducts === 5) {
      this.totalPrice = 1399;
    }else if (this.addedProducts === 6) {
      this.totalPrice = 2499;
    }
  }else if (isAuraByob) {
    if (this.addedProducts <= 2) {
      this.totalPrice = this.addedProducts * 659.8;
    } else if (this.addedProducts === 3) {
      this.totalPrice = 2199;
    } else if (this.addedProducts === 4) {
      this.totalPrice = 2799;
    } else if (this.addedProducts === 5) {
      this.totalPrice = 3299;
    }else if (this.addedProducts === 6) {
      this.totalPrice = 5999;
    }
  }else if (isFoodByob) {
    if (this.addedProducts <= 2) {
      this.totalPrice = this.addedProducts * 249.75;
        if (this.totalPriceText) {
        if (this.addedProducts === 1) {
          this.totalPriceText.innerHTML = `<span class="discount-badge">Add 3 Food to level up</span>`;
        }
      }
    } else if (this.addedProducts === 3) {
      this.totalPrice = 849;
    } else if (this.addedProducts === 4) {
      this.totalPrice = 999;
    } else if (this.addedProducts === 5) {
      this.totalPrice = 1249;
    } else if (this.addedProducts === 6) {
      this.totalPrice = 2599;
    } 
  }else if (isMyloByob) {
    if (this.addedProducts <= 2) {
      this.totalPrice = this.addedProducts * 249.5;
        if (this.totalPriceText) {
        if (this.addedProducts === 1) {
          this.totalPriceText.innerHTML = `<span class="discount-badge">Add 5 Plant to level up</span>`;
        }
      }
    } else if (this.addedProducts === 3) {
      this.totalPrice = 849;
    } else if (this.addedProducts === 4) {
      this.totalPrice = 999;
    } else if (this.addedProducts === 5) {
      this.totalPrice = 1199;
    } else if (this.addedProducts === 6) {
      this.totalPrice = 1999;
    } 
  }else if (isMylo5Byob) {
    if (this.addedProducts <= 1) {
      this.totalPrice = this.addedProducts * 200;
        if (this.totalPriceText) {
        if (this.addedProducts === 1) {
          this.totalPriceText.innerHTML = `<span class="discount-badge">Add 5 Plant to level up</span>`;
        }
      }
    } else if (this.addedProducts === 2) {
      this.totalPrice = 999;
    }else if (this.addedProducts === 3) {
      this.totalPrice = 999;
    } else if (this.addedProducts === 4) {
      this.totalPrice = 999;
    } else if (this.addedProducts === 5) {
      this.totalPrice = 999;
    } else if (this.addedProducts === 6) {
      this.totalPrice = 1899;
    } 
  } else if (isLargeByob) {
    if (this.addedProducts <= 2) {
      this.totalPrice = this.addedProducts * 1697;
      // Show individual prices for 1 product, discount for 2+ products
      if (this.totalPriceText) {
        if (this.addedProducts === 1) {
          this.totalPriceText.innerHTML = `<span class="discount-badge">Buy 2 Get 10% OFF</span>`;
        } else if (this.addedProducts === 2) {
          this.totalPriceText.innerHTML = `<span class="discount-badge">Buy 5 Get 20% OFF</span>`;
        }
      }
    } else if (this.addedProducts === 3) {
      this.totalPrice = 5093;
      if (this.totalPriceText) {
        this.totalPriceText.innerHTML = `<span class="discount-badge">Buy 5 Get 20% OFF</span>`;
      }
    } else if (this.addedProducts === 4) {
      this.totalPrice = 6791;
      if (this.totalPriceText) {
        this.totalPriceText.innerHTML = `<span class="discount-badge">Buy 5 Get 20% OFF</span>`;
      }
    } else if (this.addedProducts === 5) {
      this.totalPrice = 8489;
      if (this.totalPriceText) {
        this.totalPriceText.innerHTML = `<span class="discount-badge">Congrats You have unlocked 20% OFF</span>`;
      }
    }else if (this.addedProducts === 6) {
      this.totalPrice = 16969;
      if (this.totalPriceText) {
        this.totalPriceText.innerHTML = `<span class="discount-badge">Buy 10 Get 30% OFF</span>`;
      }
    }
  } else {
    this.totalPrice = this.addedProducts * 310;
  }

  this.normalTotalPrice = 0;
this.bundleProducts.forEach(slot => {
  if (!slot.classList.contains('bundler-product--empty')) {
    const product = slot.product;
    if (product) {
      const id = slot.dataset.id;
      const variants = product.querySelector('product-variants').getVariantData();
      const variant = variants.find(v => v.id == id);
      if (variant && variant.price) {
        this.normalTotalPrice += parseFloat(variant.price) / 100; // Shopify price is in paise
      }
    }
  }
});

  
  // Update progress bar UI
  const progressPercentage = (this.addedProducts / this._bundleMax) * 100;
  if (this.progressFill) {
    this.progressFill.style.width = `${progressPercentage}%`;
  }
  
  // Update remaining count with conditional messages
  if (this.remainingProductsText) {
    if (isLargeByob) {
      if (this.addedProducts === 0) {
        this.remainingProductsText.textContent = "Add 2 plants to level up";
      } else if (this.addedProducts === 1) {
        this.remainingProductsText.textContent = "Add 1 more plant to unlock discount";
      } else if (this.addedProducts === 2) {
        this.remainingProductsText.textContent = "10% OFF unlocked! Add more to save";
      } else if (this.addedProducts === 3) {
        this.remainingProductsText.textContent = "10% OFF - Add more to save";
      } else if (this.addedProducts === 4) {
        this.remainingProductsText.textContent = "10% OFF - Add 1 more for 20% OFF";
      } else if (this.addedProducts === 5) {
        this.remainingProductsText.textContent = "Congrats! 20% OFF unlocked";
      }else if (this.addedProducts === 6) {
        this.remainingProductsText.textContent = "Deal unlocked 20% OFF - Add 5 more for 30% OFF";
      } 
    }else if (isFoodByob) {
      if (this.addedProducts === 0) {
        this.remainingProductsText.textContent = "Add any 3 plant foods and get 25% OFF";
      } else if (this.addedProducts === 1) {
        this.remainingProductsText.textContent = "Add any 3 plant foods and get 25% OFF";
      } else if (this.addedProducts === 2) {
        this.remainingProductsText.textContent = "Add any 3 plant foods and get 25% OFF";
      } else if (this.addedProducts === 3) {
        this.remainingProductsText.textContent = "25% OFF unlocked on 3 items — add 1 more & get 30% OFF";
      } else if (this.addedProducts === 4) {
        this.remainingProductsText.textContent = "30% OFF unlocked on 4 items — add 1 more & get 40% OFF "; 
      }else if (this.addedProducts === 5) {
        this.remainingProductsText.textContent = "40% OFF unlocked on 5 items — add 5 more & get 50% OFF";
      }else if (this.addedProducts === 6) {
        this.remainingProductsText.textContent = "40% OFF unlocked on 5 items — add upto 10 & get 50% OFF "; 
      }else if (this.addedProducts === 10) {
        this.remainingProductsText.textContent = "Enjoy 50% OFF unlocked on 10 items "; 
      }
    }else if (isMyloByob) {
      if (this.addedProducts === 0) {
        this.remainingProductsText.textContent = "Add 4 Plants  for Just ₹999!";
      } else if (this.addedProducts === 1) {
        this.remainingProductsText.textContent = "Add 3 More Plants  for Just ₹999!";
      } else if (this.addedProducts === 2) {
        this.remainingProductsText.textContent = "Add 2 More Plants  for Just ₹999!";
      } else if (this.addedProducts === 3) {
        this.remainingProductsText.textContent = "Add 1 More Plants  for Just ₹999!";
      }  else if (this.addedProducts === 4) {
        this.remainingProductsText.textContent = "Deal unlocked: 4 @ ₹999 → Add 1, get 5 @ ₹1199!";
      }
       else if (this.addedProducts === 5) {
        this.remainingProductsText.textContent = "Deal unlocked: 5 @ ₹1199! → Add 5, get 10 @ ₹1999";
      } else if (this.addedProducts === 6) {
        this.remainingProductsText.textContent = "Deal unlocked: 5 @ ₹1199 → Add 5, get 10 @ ₹1999!";
      }else if (this.addedProducts === 10) {
        this.remainingProductsText.textContent = "Deal unlocked: 10 @ ₹1999";
      }
    }else if (isMylo5Byob) {
      if (this.addedProducts === 0) {
        this.remainingProductsText.textContent = "Add 5 Plants  for Just ₹999!";
      } else if (this.addedProducts === 1) {
        this.remainingProductsText.textContent = "Add 4 More Plants  for Just ₹999!";
      } else if (this.addedProducts === 2) {
        this.remainingProductsText.textContent = "Add 3 More Plants  for Just ₹999!";
      } else if (this.addedProducts === 3) {
        this.remainingProductsText.textContent = "Add 2 More Plants  for Just ₹999!";
      }  else if (this.addedProducts === 4) {
        this.remainingProductsText.textContent = "Add 1 More Plants  for Just ₹999!";
      }
       else if (this.addedProducts === 5) {
        this.remainingProductsText.textContent = "Deal unlocked: 5 @ ₹999!→ Add 5, get 10 @ ₹1899!";
      }else if (this.addedProducts === 6) {
        this.remainingProductsText.textContent = "Deal unlocked: 5 @ ₹999 → Add 5, get 10 @ ₹1899!";
      }else if (this.addedProducts === 10) {
        this.remainingProductsText.textContent = "Deal unlocked: 10 @ ₹1899";
      }
    }else if (poeticmain) {
      if (this.addedProducts === 0) {
        this.remainingProductsText.textContent = "Add 2  Plants  for Just ₹625";
      } else if (this.addedProducts === 1) {
        this.remainingProductsText.textContent = "Add 2  Plants  for Just ₹625";
      } else if (this.addedProducts === 2) {
        this.remainingProductsText.textContent = "Add 3  Plants  for Just ₹899";
      } else if (this.addedProducts === 3) {
        this.remainingProductsText.textContent = "Add 4  Plants  for Just ₹1149";
      }  else if (this.addedProducts === 4) {
        this.remainingProductsText.textContent = "Add 5  Plants  for Just ₹1399";
      }
       else if (this.addedProducts === 5) {
        this.remainingProductsText.textContent = "Deal unlocked: 5 @ ₹1399!";
      }else if (this.addedProducts === 6) {
        this.remainingProductsText.textContent = "Deal unlocked: 5 @ ₹1399 → Add 5, get 10 @ ₹2499!";
      }
    }else if (poetic2) {
      if (this.addedProducts === 0) {
        this.remainingProductsText.textContent = "Add 2  Plants  for Just ₹625";
      } else if (this.addedProducts === 1) {
        this.remainingProductsText.textContent = "Add 1 More Plant & Get 2 for ₹625!";
      } else if (this.addedProducts === 2) {
        this.remainingProductsText.textContent = "Deal unlocked: 2 @ ₹625 → Add 1, get 3 @ ₹899";
      } else if (this.addedProducts === 3) {
        this.remainingProductsText.textContent = "Deal unlocked: 3 @ ₹899 → Add 1, get 4 @ ₹1149";
      }  else if (this.addedProducts === 4) {
        this.remainingProductsText.textContent = "Deal unlocked: 4 @ ₹1149 → Add 1, get 5 @ ₹1399";
      }
       else if (this.addedProducts === 5) {
        this.remainingProductsText.textContent = "Deal unlocked: 5 @ ₹1399 → Add 5, get 10 @ ₹2499!";
      }else if (this.addedProducts === 6) {
        this.remainingProductsText.textContent = "Deal unlocked: 5 @ ₹1399 → Add 4, get 10 @ ₹2499!";
      }else if (this.addedProducts === 7) {
        this.remainingProductsText.textContent = "Deal unlocked: 5 @ ₹1399 → Add 3, get 10 @ ₹2499!";
      }else if (this.addedProducts === 8) {
        this.remainingProductsText.textContent = "Deal unlocked: 5 @ ₹1399 → Add 2, get 10 @ ₹2499!";
      }else if (this.addedProducts === 9) {
        this.remainingProductsText.textContent = "Deal unlocked: 5 @ ₹1399 → Add 1, get 10 @ ₹2499!";
      }else if (this.addedProducts === 10) {
        this.remainingProductsText.textContent = "Deal unlocked: 10 @ ₹2499!";
      }
    }else if (planters) {
      if (this.addedProducts === 0) {
        this.remainingProductsText.textContent = "Add 2 Planters for Just ₹219";
      } else if (this.addedProducts === 1) {
        this.remainingProductsText.textContent = "Add 1 more & Get 2 for ₹219";
      } else if (this.addedProducts === 2) {
        this.remainingProductsText.textContent = "Deal Unlocked: 2 @ ₹219 → Add 1, get 3 @ ₹325";
      } else if (this.addedProducts === 3) {
        this.remainingProductsText.textContent = "Deal Unlocked: 3 @ ₹325 → Add 1, get 4 @ ₹425";
      }  else if (this.addedProducts === 4) {
        this.remainingProductsText.textContent = "Deal Unlocked:4 @ ₹425 → Add 1, get 5 @ ₹549";
      }
       else if (this.addedProducts === 5) {
        this.remainingProductsText.textContent = "Deal Unlocked: 5 @ ₹549 → Add 5 more and  get 10 @ ₹999";
      }else if (this.addedProducts === 6) {
        this.remainingProductsText.textContent = "Deal Unlocked: 5 @ ₹549 → Add 4 more and  get 10 @ ₹999";
      }else if (this.addedProducts === 7) {
        this.remainingProductsText.textContent = "Deal Unlocked: 5 @ ₹549 → Add 3 more and  get 10 @ ₹999";
      }else if (this.addedProducts === 8) {
        this.remainingProductsText.textContent = "Deal Unlocked: 5 @ ₹549 → Add 2 more and  get 10 @ ₹999";
      }else if (this.addedProducts === 9) {
        this.remainingProductsText.textContent = "Deal Unlocked: 5 @ ₹549 → Add 1 more and  get 10 @ ₹999";
      }else if (this.addedProducts === 10) {
        this.remainingProductsText.textContent = "Deal Unlocked: 5 @ ₹999";
      }
    }else if (isAuraByob) {
      if (this.addedProducts === 0) {
        this.remainingProductsText.textContent = "Add 2  Plants  for Just ₹1499";
      } else if (this.addedProducts === 1) {
        this.remainingProductsText.textContent = "Add 1 More Plant & Get 2 for ₹1499!";
      } else if (this.addedProducts === 2) {
        this.remainingProductsText.textContent = "Deal unlocked: 2 @ ₹1499 → Add 1, get 3 @ ₹2199";
      } else if (this.addedProducts === 3) {
        this.remainingProductsText.textContent = "Deal unlocked: 3 @ ₹2199 → Add 1, get 4 @ ₹2799";
      }  else if (this.addedProducts === 4) {
        this.remainingProductsText.textContent = "Deal unlocked: 4 @ ₹2799 → Add 1, get 5 @ ₹3299";
      }
       else if (this.addedProducts === 5) {
        this.remainingProductsText.textContent = "Deal unlocked: 5 @ ₹3299!";
      }
    }else if (repot) {
      if (this.addedProducts === 0) {
        this.remainingProductsText.textContent = "Add 2  Plants  for Just ₹649";
      } else if (this.addedProducts === 1) {
        this.remainingProductsText.textContent = "Add 1 More Plant & Get 2 for ₹649";
      } else if (this.addedProducts === 2) {
        this.remainingProductsText.textContent = "Deal unlocked: 2 @ ₹649! → Add 1, get 3 @ ₹949";
      }else if (this.addedProducts === 3) {
        this.remainingProductsText.textContent = "Deal unlocked: 3 @ ₹949! → Add 1, get 4 @ ₹1199";
      }else if (this.addedProducts === 4) {
        this.remainingProductsText.textContent = "Deal unlocked: 4 @ ₹1199! → Add 1, get 5 @ ₹1449";
      }else if (this.addedProducts === 5) {
        this.remainingProductsText.textContent = "Deal unlocked: 5 @ ₹1449!";
      } 
    }
    else {
      if (this.addedProducts === 0) {
        this.remainingProductsText.textContent = "Add 2 plants to level up";
      } else if (this.addedProducts < this._bundleMax) {
        this.remainingProductsText.textContent = "Add 1 more plant to level up";
      } else if (this.addedProducts === this._bundleMax) {
        this.remainingProductsText.textContent = "Congrats! You unlocked max level";
      }
    }
  }
  
  // Format and display prices without decimals
  if (this.totalPriceText && !isLargeByob) {
    this.totalPriceText.textContent = `₹${this.totalPrice.toLocaleString('en-IN', {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    })}`;
  }
  
  const totalPrice2 = document.getElementById("total-price2");
  if (totalPrice2) {
    totalPrice2.textContent = this.totalPrice.toLocaleString('en-IN', {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    });
  }

  // Update per-item price display
  const perItemPrice = this.calculatePerItemPrice(this.addedProducts, this.totalPrice);
  const perItemElement = document.getElementById("per-item-price");
  if (perItemElement) {
    perItemElement.textContent = `₹${parseFloat(perItemPrice).toLocaleString('en-IN', {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    })}`;
  }
  
  // Calculate normal total (only once)
this.normalTotalPrice = 0;
this.bundleProducts.forEach(slot => {
  if (!slot.classList.contains('bundler-product--empty')) {
    const product = slot.product;
    if (product) {
      const id = slot.dataset.id;
      const variants = product.querySelector('product-variants').getVariantData();
      const variant = variants.find(v => v.id == id);
      if (variant && variant.price) {
        this.normalTotalPrice += parseFloat(variant.price) / 100; // Shopify price in paise
      }
    }
  }
});

// 🔥 Update Normal Total UI
if (this.normalTotalPriceText && this.normalTotalPriceText.length) {
  this.normalTotalPriceText.forEach(elm => {
    elm.textContent = `₹${this.normalTotalPrice.toLocaleString('en-IN', {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    })}`;
  });
}

// 🔥 Calculate Savings = Normal - Discounted
this.savings = this.normalTotalPrice - this.totalPrice;
if (this.savings < 0) this.savings = 0;

// 🔥 Update Savings UI
if (this.savingsText && this.savingsText.length) {
  this.savingsText.forEach(elm => {
    elm.textContent = `₹${this.savings.toLocaleString('en-IN', {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    })}`;
  });
}

}
    // Rest of the methods remain the same...
    findEmptySlot() {
      return this.bundleProducts.find(elm => {
        return elm.classList.contains('bundler-product--empty');
      });
    }

    clearSlot(slot) {
      if (this.bundleProducts.length > this._bundleMin) {
        this.bundleProducts.splice(this.bundleProducts.indexOf(slot), 1);
        slot.remove();
        slot.product.classList.remove('product-item--bundled');
      } else {
        slot.product.classList.remove('product-item--bundled');
        slot.dataset.id = "";
        slot.product = null;
        slot.classList.add('bundler-product--empty');
        slot.querySelector('[data-js-bundler-product-text]').innerHTML = '';
        slot.querySelector('[data-js-bundler-product-image]').innerHTML = '';
      }

      const product = slot.product;
      if (product) {
        const addToCartButton = product.querySelector('[data-js-product-add-to-cart]');
        if (addToCartButton) {
          addToCartButton.querySelector('.button__text').innerHTML = "Add to box";
        }
      }

      if (this.findEmptySlot()) {
        this.classList.remove('bundler-full');
      }
      this.reorderSlots();
      this.updateAddToCartButton();
      this.syncStickyBar();

    }

    reorderSlots() {
      let ei = 0,
        fi = -100;
      this.querySelectorAll('[data-js-bundler-product]').forEach((elm, i) => {
        if (elm.classList.contains('bundler-product--empty')) {
          elm.style.order = ei++;
        } else {
          elm.style.order = fi++;
        }
      });
    }

    createSlot() {
      const newSlot = this._bundleTemplate.cloneNode(true);
      newSlot.querySelector('[data-js-bundler-product-remove]').addEventListener('click', e => {
        this.clearSlot(e.target.closest('[data-js-bundler-product]'));
        this.updateProgressBar(-1);
        this.dispatchBundleUpdatedEvent();
      });
      this.querySelector('[data-js-bundler-products]').appendChild(newSlot);
      this.bundleProducts.push(newSlot);
    }

    addToBundle(variant, product) {
      let slot = this.findEmptySlot();
      const imageSrc = variant.featured_image ? variant.featured_image.src : product.querySelector('[data-js-quick-buy-product-image]').textContent;

      if (!slot && this.bundleProducts.length < this._bundleMax) {
        this.createSlot();
        slot = this.findEmptySlot();
      }

      if (slot) {
        slot.classList.remove('bundler-product--empty');
        slot.querySelector('[data-js-bundler-product-text]').innerHTML = `
          <span class="bundler-product__text-title text-line-height--medium text-weight--bold">${product.querySelector('[data-js-quick-buy-product-title]').textContent}</span>
          ${product.querySelector('product-variants').hasAttribute('data-has-variants') ? `<span class="bundler-product__text-variant text-color--opacity">${variant.title}</span>` : ''}
        `;
        slot.querySelector('[data-js-bundler-product-image]').innerHTML = `
          <img src="${this.getResizedImageSrc(imageSrc, 60)}"
            srcset="
              ${this.getResizedImageSrc(imageSrc, 60)} 60w,
              ${this.getResizedImageSrc(imageSrc, 120)} 120w,
              ${this.getResizedImageSrc(imageSrc, 180)} 180w
            "
            sizes="60px"
          />
        `;

        if (this.hasAttribute('data-limit-bundles')) {
          product.classList.add('product-item--bundled');
        }
        slot.product = product;
        slot.dataset.id = product.querySelector('input[name="id"]').value;
      }

      if (!this.findEmptySlot() && this.bundleProducts.length < this._bundleMax) {
        this.createSlot();
      }

      this.updateAddToCartButton();
      this.syncStickyBar();

    }

    getResizedImageSrc(src, size, crop = 'center') {
      return (`${src}${src.includes('?') ? '&' : '?'}width=${size}&height=${size}&crop=${crop}`).replace(/\n|\r|\s/g, "");
    }

    addBundleToCart() {
      if (this.bundleProducts.filter(elm => !elm.classList.contains('bundler-product--empty')).length >= this._bundleMin) {
        let items = [];
        this.bundleProducts.map(elm => {
          if (elm.dataset.id) {
            if (!items.find(item => {
              if (item.id == elm.dataset.id) {
                item.quantity++;
                return true;
              }
            })) {
              items.push({
                id: elm.dataset.id,
                quantity: 1
              });
            }
          }
        });

        if (items.length > 0) {
          const submitButton = this.querySelector('[data-js-add-bundle-to-cart]');
          submitButton.classList.add('working');
          window.handleAddToCart(
            JSON.stringify({ 'items': items }), items.reduce((total, { quantity }) => total + quantity, 0),
            { 'Content-Type': 'application/json' },
            () => {
              submitButton.classList.remove('working');
              this.querySelectorAll('[data-js-bundler-product]').forEach(elm => {
                this.clearSlot(elm);
              });
              this.classList.remove('opened');
              this.addedProducts = 0;
              this.totalPrice = 0;
              this.updateProgressBar(0);
              this.dispatchBundleUpdatedEvent();
            }
          );
        }
      }
    }

    updateAddToCartButton() {
      const filledSlots = this.bundleProducts.filter(elm => !elm.classList.contains('bundler-product--empty')).length;
      const addToCartButtons = this.querySelectorAll('[data-js-product-add-to-cart]');
      const submitButton = this.querySelector('[data-js-add-bundle-to-cart]');
      const infoElement = this.querySelector('[data-js-bundler-info]');
      
      const isCustomBundle = document.body.classList.contains('template-page-custom-bundle');
      const isAuraByob = document.body.classList.contains('template-page-aura-byob');
      const isLargeByob = document.body.classList.contains('template-page-large-bundle');
        const isFoodByob = document.body.classList.contains('template-page-plant_food_byob');
      
      if (filledSlots >= this._bundleMin) {
        this.classList.add('bundler-full');
      } else {
        this.classList.remove('bundler-full');
      }
      
      if (filledSlots >= this._bundleMax) {
        addToCartButtons.forEach(button => {
          button.disabled = true;
          button.querySelector('.button__text').innerHTML = "Bundle Full";
          button.classList.add('bundle-full-products');
          button.classList.remove('selectfirstavailablevariant');
        });
      } else {
        addToCartButtons.forEach(button => {
          button.disabled = false;
          button.querySelector('.button__text').innerHTML = "Add to box";
          button.classList.remove('bundle-full-products');
        });
      }
      
      if (isCustomBundle) {
        if (filledSlots === 0) {
          infoElement.innerHTML = "Add 2 plants to get started";
        } else if (filledSlots === 1) {
          infoElement.innerHTML = "Add 1 more plant to unlock Level 1";
        } else if (filledSlots === 2) {
          infoElement.innerHTML = `
            <span class="level-text">Level 1 - ₹625 (2 Plants) 🌱</span>
            <span class="message-text">You're a Plant Parent! Add 1 more for ₹374 & level up!</span>
          `;
        } else if (filledSlots === 3) {
          infoElement.innerHTML = `
            <span class="level-text">Level 2 - ₹999 (3 Plants) 🌿</span>
            <span class="message-text">Green Guardian unlocked! Add 1 more for ₹300!</span>
          `;
        } else if (filledSlots === 4) {
          infoElement.innerHTML = `
            <span class="level-text">Level 3 - ₹1299 (4 Plants) 🌱</span>
            <span class="message-text">Botanical Master status! Add 1 more for ₹250!</span>
          `;
        } else if (filledSlots === 5) {
          infoElement.innerHTML = `
            <span class="level-text">Level 4 - ₹1549 (5 Plants) 🎉</span>
            <span class="message-text">Leaf Legend achieved! Enjoy your thriving jungle! 🌿🏡</span>
          `;
        }
      } else if (isAuraByob) {
        if (filledSlots >= 0 && filledSlots < 2) {
          infoElement.innerHTML = "Add 2 products @ ₹1199";
        } else if (filledSlots === 2) {
          infoElement.innerHTML = `Add one more plant for just ₹700 
                        <span class="bundle-total2">Bundle Total - ₹1199</span>`;
        } else if (filledSlots > 2 && filledSlots == 3) {
          infoElement.innerHTML = `Add one more plant for just ₹500 
                        <span class="bundle-total2">Bundle Total - ₹1899</span>`;
        } else if (filledSlots > 3 && filledSlots == 4) {
          infoElement.innerHTML = `Add one more plant for just ₹500
                        <span class="bundle-total2">Bundle Total - ₹2399</span>`;
        } else if (filledSlots >= 4) {
          infoElement.innerHTML = `<span class="bundle-total2">Bundle Total - ₹2899</span>`;
        } else {
          infoElement.innerHTML = "";
        }
      } else if (isLargeByob) {
        if (filledSlots === 0) {
          infoElement.innerHTML = "Add 2 plants to get started";
        } else if (filledSlots === 1) {
          infoElement.innerHTML = "Add 1 more plant to unlock 15% OFF";
        } else if (filledSlots === 2) {
          infoElement.innerHTML = `
            <span class="level-text">15% OFF - 2 Plants</span>
            <span class="message-text">Add more plants to save even more!</span>
          `;
        } else if (filledSlots === 3) {
          infoElement.innerHTML = `
            <span class="level-text">15% OFF - 3 Plants</span>
            <span class="message-text">Add 2 more for 30% OFF!</span>
          `;
        } else if (filledSlots === 4) {
          infoElement.innerHTML = `
            <span class="level-text">15% OFF - 4 Plants</span>
            <span class="message-text">Add 1 more for 30% OFF!</span>
          `;
        } else if (filledSlots === 5) {
          infoElement.innerHTML = `
            <span class="level-text">30% OFF - 5 Plants 🎉</span>
            <span class="message-text">Maximum savings unlocked!</span>
          `;
        }
      } else {
        infoElement.innerHTML = "";
      }
    }
  }

  if (typeof customElements.get('product-bundler') == 'undefined') {
    customElements.define('product-bundler', ProductBundler);
  }
}

// Rest of your popup and initialization code remains the same...

function initPopupFunctionality() {
  let popup = document.querySelector(".cutom_popup_sec_cus");
  if (!popup) return;
  
  let overlay = document.createElement("div");
  overlay.classList.add("popup-overlay");
  document.body.appendChild(overlay);

  let viewCartButtons = document.querySelectorAll(".View_cart_cus");
  let addMoreButton = document.querySelector(".addmore");

  popup.style.display = "none";
  overlay.style.display = "none";

  let productCount = 0;
  let progressBar = document.querySelector(".progress-fill");

  const levels = [
    { 
      level: "Level 0", 
      text: "Leaf Admirer", 
      next: "Add 2 plants to level up",
      image: "https://cdn.shopify.com/s/files/1/0646/8327/8550/files/Level-1.gif?v=1743671342"
    },
    {
      level: "Level 01", 
      text: "Leaf Admirer", 
      next: "Add 1 more plant to level up",
      image: "https://cdn.shopify.com/s/files/1/0646/8327/8550/files/Level-1.gif?v=1743671342"
    },
    {
      level: "Level 02", 
      text: "Plant Parent", 
      next: "Add 1 more plant to level up",
      image: "https://cdn.shopify.com/s/files/1/0646/8327/8550/files/Lvl-1-to-Lvl-2.gif?v=1743671342"
    },
    {
      level: "Level 03", 
      text: "Green Guardian", 
      next: "Add 1 more plant to level up",
      image: "https://cdn.shopify.com/s/files/1/0646/8327/8550/files/Lvl-2-to-Lvl-3.gif?v=1743671342"
    },
    {
      level: "Level 04", 
      text: "Botanical Master", 
      next: "Add 1 more plant to level up",
      image: "https://cdn.shopify.com/s/files/1/0646/8327/8550/files/Lvl-3-to-Lvl-4.gif?v=1743671342"
    },
    {
      level: "Level 05", 
      text: "Botanical Master", 
      next: "Congrats! You unlocked max level",
      image: "https://cdn.shopify.com/s/files/1/0646/8327/8550/files/Lvl-3-to-Lvl-4.gif?v=1743671342"
    }
  ];

  function updatePopupContent(count, totalPrice) {
    productCount = count;

    const levelMessages = [
      {
        level: "Level 1",
        title: "Plant Parent",
        message: "Add 1 more & become a Leaf Legend — save up to 35%!",
        image: "https://cdn.shopify.com/s/files/1/0646/8327/8550/files/Level-1.gif?v=1743671342" 
      },
      {
        level: "Level 2",
        title: "Botanical Master!",
        message: "Add 1 more & become a Leaf Legend — save up to 35%!",
        image: "https://cdn.shopify.com/s/files/1/0646/8327/8550/files/Lvl-1-to-Lvl-2.gif?v=1743671342" 
      },
      {
        level: "Level 3",
        title: "Leaf Legend!",
        message: "Your green haven is complete — you've unlocked the best deal!",
        image: "https://cdn.shopify.com/s/files/1/0646/8327/8550/files/Lvl-2-to-Lvl-3.gif?v=1743671342"
      }
    ];

    const adjustedCount = Math.max(0, Math.min(count - 3, levelMessages.length - 1));
    const levelConfig = levelMessages[adjustedCount];

    // Update popup image
    const popupImage = document.querySelector('.popup_top_content img');
    if (popupImage) {
      popupImage.src = '';
      setTimeout(() => {
        popupImage.src = levelConfig.image;
        popupImage.alt = `Gift Box ${levelConfig.level}`;
      }, 50);
    }

    // Update text elements
    const levelElement = document.querySelector(".popup_top_content .level");
    const titleElement = document.querySelector(".popup_top_content .what_user_become");
    const messageElement = document.querySelector(".popup_top_content .onemore_add");

    if (levelElement) levelElement.textContent = levelConfig.level;
    if (titleElement) titleElement.textContent = levelConfig.title;
    if (messageElement) messageElement.innerHTML = levelConfig.message;

    updateProgressBar();
  }

  function updateProgressBar() {
    let maxProducts = 5;
    let progressPercentage = (productCount / maxProducts) * 100;
    if (progressPercentage > 100) progressPercentage = 100;
    if (progressPercentage < 0) progressPercentage = 0;

    if (progressBar) {
      progressBar.style.width = `${progressPercentage}%`;
    }
    this.syncStickyBar();

  }

  function initializeCounters() {
    const bundler = document.querySelector('product-bundler');
    if (bundler) {
      if (bundler.remainingProductsText) {
        if (document.body.classList.contains('template-page-large-bundle')) {
          bundler.remainingProductsText.textContent = "Add 2 Plants to get 10% OFF";
        }else if (document.body.classList.contains('template-page-plant_food_byob')) {
          bundler.remainingProductsText.textContent = "Add 3 plants Food to level up";
        }else if (document.body.classList.contains('template-page-planter_byob')) {
          bundler.remainingProductsText.textContent = "Add 2 Planters for Just Rs.219";
        } else {
          bundler.remainingProductsText.textContent = "Add 2 plants to level up";
        }
      }
      
      if (bundler.totalPriceText) {
        bundler.totalPriceText.textContent = '₹0';
      }
      
      const totalPrice2 = document.getElementById("total-price2");
      if (totalPrice2) {
        totalPrice2.textContent = '0';
      }
      
      // Set initial empty box image
      const popupImage = document.querySelector('.popup_top_content img');
      if (popupImage) {
        popupImage.src = levels[0].image;
        popupImage.alt = `Gift Box ${levels[0].level}`;
      }
      
      updatePopupContent(0, 0);
    }
  }

  // document.addEventListener('bundle-updated', function(e) {
  //   updatePopupContent(e.detail.count, e.detail.totalPrice);
    
  //   if (e.detail.count > 2) {
  //     popup.style.display = "block";
  //     overlay.style.display = "block";
  //   } else if (e.detail.count === 0) {
  //     popup.style.display = "none";
  //     overlay.style.display = "none";
  //   }
  // });

  viewCartButtons.forEach(button => {
    button.addEventListener("click", function() {
      popup.style.display = "block";
      overlay.style.display = "block";
    });
  });

  if (addMoreButton) {
    addMoreButton.addEventListener("click", function() {
      popup.style.display = "none";
      overlay.style.display = "none";
    });
  }

  document.addEventListener("DOMContentLoaded", function() {
    initializeCounters();
  });
}

// Initialize everything when DOM is loaded
document.addEventListener("DOMContentLoaded", function() {
  if (typeof ProductBundler === 'function') {
    customElements.define('product-bundler', ProductBundler);
  }
  initPopupFunctionality();
});